import { create } from 'zustand';

type FilterState = {
  [key: string]: string | number | boolean | undefined | (string | number | boolean | undefined)[];
};

type FilterStore = {
  filters: FilterState;
  order: 'asc' | 'desc';
  orderBy: string;
  page: number;
  limit: number;
  total: number;
  setOrder: (order: 'asc' | 'desc') => void;
  setOrderBy: (orderBy: string) => void;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  setTotal: (total: number) => void;
  setFilter: (key: keyof FilterState, value: FilterState[typeof key]) => void;
  setFilters: (partial: Partial<FilterState>) => void;
  resetFilters: () => void;
  removeFilter: (key: keyof FilterState) => void;
};

const defaultFilters: FilterState = {};

export const useFilterStore = create<FilterStore>((set) => ({
  filters: { ...defaultFilters },
  order: 'asc',
  orderBy: 'status',
  page: 0,
  limit: 15,
  total: 0,
  setOrder: (order) => set({ order }),
  setOrderBy: (orderBy) => set({ orderBy }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit }),
  setTotal: (total) => set({ total }),
  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),
  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial },
    })),
  resetFilters: () => set({ filters: { ...defaultFilters } }),
  removeFilter: (key) =>
    set((state) => {
      const newFilters = { ...state.filters };
      delete newFilters[key];
      return { filters: newFilters };
    }),
}));
